module.exports = __webpack_public_path__ + "static/media/mac.e48fccda.png";